import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';

import { credentialsInterceptor } from '@interceptors/auth/auth.interceptor';
import { httpErrorFeedbackInterceptor } from '@interceptors/http-error-feedback/http-error-feedback.interceptor';
import { recaptchaInterceptor } from '@interceptors/recaptcha/recaptcha.interceptor';
import { refreshInterceptor } from '@interceptors/refresh/refresh.interceptor';
import { serverErrorReferenceInterceptor } from '@interceptors/server-error-reference/server-error-reference.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideHttpClient(
      withFetch(),
      withInterceptors([credentialsInterceptor, refreshInterceptor, recaptchaInterceptor, serverErrorReferenceInterceptor, httpErrorFeedbackInterceptor]),
    ),
  ],
};
